import React, { useState, useEffect } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import Footer from "../Footer/Footer";
import { Scroll } from "../Scroll function/scroll";
import Axios from "../../config/Axios";
import Prefix from "../../config/ApiPrefix";
import AddressPopUp from "../Redcliffe-Imaging/AddressPopUp";
import { paymentUpadte } from "../../Redux/Actions";

import moment from "moment";
import {
  customerBookingDetails,
  getReportStatus,
  getCustomerDashboard,
  AddtoCart,
} from "../../Redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import { razorKey } from "../../config/Axios";
import "./Orders.css";
import { ToggleMenu } from "./UserProfile";
import { Link, useHistory, useLocation } from "react-router-dom";
import NewHeader from "../NewHeader/NewHeader";
import { Modal } from "react-responsive-modal";
import LpForm from "../../Pages/LandingPages/Component/LpForm";
import Loader from "../Loader/Loader";
import { FaArrowLeft, FaAngleRight, FaPhoneAlt } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import Meta from "../Meta";
import { object } from "prop-types";
import { SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS } from "../../Redux/Constants";

export const BackToscreen = ({ title }) => {
  return <div className="currentWindow">{title}</div>;
};

function ActiveDashboard() {
  const history = useHistory();
  // console.log(razorKey,"+++++++++++++++++++++++++++")
  //handel razorpay

  const handlePressEvent = (values) => {
    // BookingApiPromise(values).then((response) => {
    var options = {
      //  key : "rzp_test_kBEHIT9OH5OYyo",
      // key: razorKey,
      key: "rzp_live_sDovuuBgCu9dw3",
      amount: parseInt(values?.amount?.receivable_amount) * 100,
      // amount: parseInt(response?.discounted_price?.final_total_price) * 100,
      currency: "INR",
      name: "Redcliffe Labs",
      description: `Credit Towards ${values?.customer_name}`,
      handler: function (response) {
        const body = {
          paymentid: response?.razorpay_payment_id,
          bookingid: values?.pk,
        };
        const datekey = JSON.parse(localStorage.getItem("user"));
        dispatch(paymentUpadte(datekey?.token, body));
        console.log("==>razor data", response);
        setTimeout(() => {
          history.push({
            pathname: `/confirmed`,
            from: "/order",

            state: response,
          });
        }, 500);
      },
      prefill: {
        name: values?.customer_name,
        email: values?.customer_email,
        contact: values?.customer_phonenumber,
      },
      notes: {
        bookingid: values?.pk,
      },
      theme: {
        color: "#0a406b",
      },
    };
    var rzp1 = new window.Razorpay(options);
    rzp1.open();

    localStorage.setItem("bookingid", values?.pk);

    // .catch((error) => {
    //   console.log(error.message);
    // });
  };

  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [currentNav, setCurrentNav] = useState(false);
  const [filArray, setfilteredArray] = useState([]);
  const [UpcomingArray, setUpcomingArray] = useState([]);
  const dispatch = useDispatch();
  const [openImgcrt, setOpenImgcrt] = useState(false);
  const [cardId, setCartId] = useState("");
  const [cardSlug, setCardSlug] = useState("gg");
  const [cardData, setCardData] = useState({});
  const onOpenImgcrtModal = () => {
    setOpenImgcrt(true);
    console.log(cardSlug, "hgf");
  };

  const onCloseImgcrtModal = () => setOpenImgcrt(false);

  const citySelected = useSelector((state) => state.cityOnTopNav);
  //customer data
  const customerBooking = useSelector((state) => state.customerBookingDetails);
  const { loading, customerDetailResponse } = customerBooking;
  var dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
 
  customerDetailResponse?.results?.map((item) => {
    var dateThen = moment(new Date()).format(`${item?.collection_date} 00:00:00`)
    var timeDiff = moment(dateThen, "YYYY-MM-DD HH:mm:ss").diff(moment(dateNow, "YYYY-MM-DD HH:mm:ss"))
    console.log(item?.collection_date, "<<<", moment(new Date()).format("YYYY-MM-DD HH:mm:ss"), timeDiff, "<<<")
  })
  //customer report data
  const reportdetail = useSelector((state) => state.ReportReducer);


  const { loading: reportStatus, report } = reportdetail;
  const location = useLocation();

  //   if(report){

  

  // }

  const filterArray = (arrayData) => {
    var dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
    if (arrayData) {
      const filteredArray =
        arrayData &&
        arrayData?.filter((values) => {
          var dateThen = moment(new Date()).format(`${values?.collection_date} 00:00:00`)
          var timeDiff = moment(dateThen, "YYYY-MM-DD HH:mm:ss").diff(moment(dateNow, "YYYY-MM-DD HH:mm:ss"))
          console.log(timeDiff, "<<<///")
          // values.report_status == "consolidate" ||
          // values.report_status == "partial"
          return (
            timeDiff < 0 || values?.report_status == "consolidate" || values?.report_status == "partial"
          );
        });
      const unConfirmed =
        // val.report_status == "none" || val.report_status == "pending";
        arrayData &&
        arrayData?.filter((values) => {
          var dateThen = moment(new Date()).format(`${values?.collection_date} 00:00:00`)
          var timeDiff = moment(dateThen, "YYYY-MM-DD HH:mm:ss").diff(moment(dateNow, "YYYY-MM-DD HH:mm:ss"))
          return (
            timeDiff > 0
          );
        });
      setUpcomingArray(unConfirmed);
      setfilteredArray(filteredArray);
    }
  };

  useEffect(() => {
    Scroll();
    if (loading) {
    } else {
      filterArray(customerBooking.customerDetailResponse.results);
      filterArray(customerBooking.customerDetailResponse.res);
    }
  }, [loading]);

  //get DOWNLOAD PDF
  const pdfDownload = (string, name) => {
    const date = new Date();
    var b64 = string;
    console.log("bs string i want", b64);
    var bin = window.atob(b64);
    // console.log("File Size:", Math.round(bin.length / 1024), "KB");
    console.log("PDF Version:", bin.match(/^.PDF-([0-9.]+)/)[1]);

    // Insert a link that allows the user to download the PDF file
    var link = document.createElement("a");
    // link.innerHTML = 'Download PDF file';
    link.download = `${name}-${date.toLocaleDateString("en-US")}.pdf`;
    link.href = "data:application/octet-stream;base64," + b64;
    // window.document.getElementsByClassName(".letsdownl").innerHTML=link
    link.click();
  };
  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    dispatch(getCartDetails(token, citySelected && citySelected.citySelect));
  };

  //addt o cart
  const addtocart = (packageid) => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;

    const body = {
      package: packageid,
    };

    if (token && token !== "" && token) {
      dispatch(AddtoCart(body, token, successCb));
      history.push("/cart");
    } else {
      history.push({
        pathname:"/login",
        pushToUrl:"myOrders",
        packageId:packageid
    });
    }
  };
  const addtocartImg = (card, name, id) => {
    console.log(name, "hwqfger");
    setCartId(id);
    setCardSlug(name.replaceAll(" ", "-").toLowerCase());
    setCardData(card);

    onOpenImgcrtModal();
  };
  useEffect(() => {
    const datakey = JSON.parse(localStorage.getItem("user"));
    if (!datakey) {
      history.push({
        pathname: `/login`,
        pushToUrl: "myOrders",
      });
    }
  }, []);

  ///

  //get report status
  const downloadReport = (userId, date, isAdditional) => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;

    dispatch(getReportStatus(userId, token, isAdditional));
  };

  useEffect(() => {
    reportdetail?.report?.allReportDetails && reportdetail.report.allReportDetails.reportDetails !== "" ?
      pdfDownload(
        reportdetail.report.allReportDetails.reportDetails,
        reportdetail.report.allReportDetails.Patient_Name,
        dispatch({
          type: "EPMTY_REPORT_OJECT",
        })
      ) : (
        reportdetail?.report?.message
          ? alert(
            reportdetail?.report?.message
          )
          : reportdetail?.error ? (alert(reportdetail?.error?.response?.data?.detail)) : null
      )
  }, [reportdetail])

  //CALLING CUSTOMER DETAILS ACTION
  useEffect(() => {
    const datakey = JSON.parse(localStorage.getItem("user"));
    if (datakey) {
      const token = datakey.token;
      dispatch(customerBookingDetails(token));
      dispatch(getCustomerDashboard(token));
    }
  }, []);

  const [login, setlogin] = useState(false);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (userDetails && userDetails.token) {
      setlogin(true);
    } else {
      setlogin(false);
    }
  }, []);

  const [calculatedOffer, setCalculatedOfferprice] = useState(0);

  //offerprice calculate
  const calculateOfferprice = (values) => {
    console.log("function call", values);

    var numAdd = 0;

    values.map((val) => {
      if (val.is_addon) {
        numAdd = numAdd + 1;
        console.log("numcount", numAdd);
      }
    });

    if (values.length == numAdd) {
      setCalculatedOfferprice(values.offer_price);
    } else {
      if (values.is_addon) {
        setCalculatedOfferprice(values.addon_price);
      } else {
        setCalculatedOfferprice(values.offer_price);
      }
    }
  };

  useEffect(() => {
    if (loading) {
    } else {
      UpcomingArray &&
        UpcomingArray.length > 0 &&
        UpcomingArray.map((values) => {
          calculateOfferprice(values.packages);
        });
    }
  }, [loading, UpcomingArray, calculatedOffer]);
  /////////////////////
  const PackDisplayblock = ({ item }) => {
    const [packItem, setPackItem] = useState(item);
    const [addOnState, setAddOnState] = useState(false);

    useEffect(() => {
      setAddOnState(false);
      packItem.map((item, index) => {
        if (item.is_addon) {
          if (index + 1 == packItem.length) {
            setAddOnState(true);
            console.log("ALL TRUE");
          }
        }
      });
    }, []);

    return packItem.map((values) => {
      return (
        <>
          <div className="testName" key={values.id}>
            <span className="testNamebg">
              <span className="">{values.name}</span>
            </span>
            <span>
              Paid:
              <span className="textBold_grey">
                Rs{" "}
                {addOnState
                  ? values.package_city_prices
                    ? values.package_city_prices.offer_price
                    : values.offer_price
                  : values.is_addon
                    ? values.addon_price
                    : values.package_city_prices
                      ? values.package_city_prices.offer_price
                      : values.offer_price}
              </span>
            </span>
          </div>
        </>
      );
    });
  };

  console.log("compled array", filArray);
  const Inclusions = ({ val, customer }) => {
    console.log(val, "SDsdsd==>val");
    const [showInc, setInc] = useState(false);
    const showInclusion = () => {
      setInc(!showInc);
    };
    return (
      <>
        <div className="pacDrop" onClick={showInclusion}>
          <span>All Inclusions in this booking</span>
          <span>{!showInc ? <BsChevronDown /> : <BsChevronUp />}</span>
        </div>

        <div className={showInc ? "shownc bookedTestDetails" : "hideInc"}>
          {val.packages.length > 0 &&
            val.packages.map((packageArray, index) => {
              return (
                <div className="testName" key={packageArray.id}>
                  <span className="testNamebg">
                    <span className="">{packageArray.name}</span>
                  </span>
                  {currentNav && val.report_status == "none" ? (
                    <div className="downloadReportDiv">
                      <span
                        onClick={() => {
                          if (val.org_type == "homedx") {
                            addtocart(packageArray.id);
                          } else {
                            addtocartImg(
                              packageArray,
                              packageArray.name,
                              packageArray.id
                            );
                          }
                        }}
                        className=" book_nowBtn"
                      >
                        Book Again
                      </span>
                    </div>
                  ) : (
                    <div className="downloadReportDiv">
                     {currentNav ? <span
                        className="download_button"
                        onClick={() => addtocart(packageArray.id)}
                      >
                        Book Again
                      </span> : <></> }
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </>
    );
  };
  return (
    <>
      <Meta>
        <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
      </Meta>
      <NewHeader />
      <Modal open={open} onClose={onCloseModal} center>
        <LpForm
          butname={"SUBMIT"}
          title={"Book Your Test"}
          position={"orderDashboard"}
        />
      </Modal>
      <Modal
        open={openImgcrt}
        onClose={onCloseImgcrtModal}
        // center
        classNames={{
          overlay: "customAddressOverlay",
          modal: "customAddressModal",
        }}
      >
        <AddressPopUp
          butname={"SUBMIT"}
          title={"Book Your Test"}
          fromCart={true}
          card={cardData}
          cartId={cardId}
          position={"Banner"}
          slug={cardSlug}
          Close={onCloseImgcrtModal}
        />
      </Modal>
      <div className="activeDashboard">
        <div className="dashboard_content">
          <div className="back_btn">
            {/* <Link to="/userdashboard">
              <FaArrowLeft /> Back to dashboard
            </Link> */}
          </div>
          <BackToscreen title="My Orders" />
          <div className="dashboardChildContent">
            <div className="dashboard_contentLeft">
              <ToggleMenu isOrder={true} isLogin={login} />
            </div>
            <div className="dashboard_contentRight">
              <div className="toggleOrder">
                <span
                  className={
                    currentNav ? "toggleTexxt" : "toggleTexxt currentToogle"
                  }
                  onClick={() => setCurrentNav(!currentNav)}
                >
                  Upcoming
                </span>
                <span
                  className={
                    currentNav ? "toggleTexxt  currentToogle" : "toggleTexxt"
                  }
                  onClick={() => setCurrentNav(!currentNav)}
                >
                  Completed
                </span>
              </div>
              {/* 
              {loading ? (
                <Loader />
              ) : (
                   
                customerDetailResponse && customerDetailResponse.results && customerDetailResponse.results.map((val) => (
                   <p>helo</p>
                 ))
                
              )
              } */}
              {/* COMPLETED ORDERS */}

              {loading ? (
                <Loader />
              ) : currentNav ? (
                filArray && filArray == "" ? (
                  <div className="" style={{ padding: "3rem" }}>
                    <h2>NO COMPLETED BOOKING</h2>
                  </div>
                ) : (
                  filArray.map((val, index) => {
                    console.log(val.report_status,"<<<<<")
                    return (
                      <div className="bookingDiv" key={val?.pk}>
                        <div className="bookingTop blueBold">
                          <span className="hideMobile">
                            Booking ID :{" "}
                            <span className="textBold_grey">{val?.pk}</span>
                          </span>
                          <div className="priceDetail addMemMargin">
                            <span style={{ marginRight: "2rem" }}>
                              Qty :{" "}
                              <span className="textBold_grey">
                                {1 + val?.additional_members.length}
                              </span>
                            </span>
                            <span>
                              <span className="pickupdate">
                                Rs.{val.amount.receivable_amount}/-
                              </span>{" "}
                            </span>
                          </div>
                        </div>
                        <div className="bookingDetailsDiv bookingDetailsDivWaddMem">
                          <span className="hideDesktop">
                            Booking ID :{" "}
                            <span className="textBold_grey">{val.pk}</span>
                          </span>
                          <div className="addMemMargin">
                            Booked date:{" "}
                            <span className="textBold_grey">
                              {moment(val?.booking_date).format("Do MMM YYYY")}
                            </span>
                          </div>
                          <div className="addMemMargin">
                            Payment:{" "}
                            <span className="textBold_grey">
                              {val.amount?.receivable_amount > 0
                                ? "Pending"
                                : "Completed"}
                            </span>
                          </div>

                          <div className="addMemMargin">
                            Transaction ID:{" "}
                            <span className="textBold_grey">
                              {val?.payment_source ? val?.payment_source : "NA"}
                            </span>
                          </div>
                          <div className="bookedFor addMemDownload">
                            <div className="patientDetail">
                              Booked for:&nbsp;
                              <span className="textBold_grey">
                                {val.customer_name}
                              </span>
                            </div>
                            {val?.report_status == "consolidate" ||
                              val?.report_status == "partial" ?
                              <button
                                className=" book_nowBtn"
                                onClick={() =>
                                  downloadReport(val.pk, val.collection_date, false)
                                }
                              >
                                Download Report
                              </button> : <></>}
                          </div>
                          {val?.additional_members.filter((mem) => (mem.bill_id && mem.report_status == "partial" || mem.report_status == "consolidate")).map((usr) => {
                            return (<div>
                              <div className="bookedFor addMemDownload">
                                <div className="patientDetail">
                                  Booked for:&nbsp;
                                  <span className="textBold_grey">
                                    {usr.customer_name}
                                  </span>
                                </div>
                                <button
                                  className=" book_nowBtn"
                                  onClick={() =>
                                    downloadReport(usr.id, val.collection_date, true)
                                  }
                                >
                                  Download Report
                                </button>
                              </div>
                            </div>)
                          })}
                        </div>
                        <div className="borderCon" />
                        {/**drop down here */}
                        <Inclusions val={val} customer={val.customer_name} />
                      </div>
                    );
                  })
                )
              ) : UpcomingArray && UpcomingArray == "" ? (
                <div className="" style={{ padding: "3rem" }}>
                  <h2>NO UPCOMING BOOKING</h2>
                </div>
              ) : (
                UpcomingArray &&
                UpcomingArray.map((val, index) => {
                  return (
                    <>
                      <div className="bookingDiv">
                        <div className="bookingTop blueBold">
                          <span className="hideMobile">
                            Booking ID :{" "}
                            <span className="textBold_grey">{val.pk}</span>
                          </span>
                          <div className="priceDetail">
                            <span style={{ marginRight: "2rem" }}>
                              Qty:{" "}
                              <span className="textBold_grey">
                                {1 + val.additional_members.length}
                              </span>
                            </span>
                            {/* <span>
                              OP :
                              <span className="textBold_grey">
                                {" "}
                                Rs{" "}
                                {calculateTotalPrice(val)
                                // val?.discounted_price.counpon_discount > 0 ? (val.discounted_price.final_total_price -  val?.discounted_price.counpon_discount ) : ( val.phlebo_cost > 0 ? (val.discounted_price.final_total_price+val.phlebo_cost) : (val.discounted_price.final_total_price))
                                }
                              </span>
                              {
                                //total_price_package
                              }
                            </span> */}
                            <span className="paidSucces">
                              {/* {val.amount.paid_amount !==0 ? (<span >Paid Rs .{val.amount.paid_amount} /-</span>) : (<span >UnPaid Rs{val.amount.} /-</span>
                              } */}
                              <span style={{ marginRight: "1rem" }}>
                                Total Rs.{" "}
                                {val.discounted_price.final_total_price}/-
                              </span>{" "}
                              ,
                              {val.amount.paid_amount > 0 && (
                                <span style={{ marginRight: "1rem" }}>
                                  Paid Rs.{val.amount.paid_amount}/-
                                </span>
                              )}
                              {val.amount.receivable_amount > 0 && (
                                <span
                                  style={{
                                    color: "orange",
                                    marginRight: "1rem",
                                  }}
                                >
                                  Unpaid Rs.{val.amount.receivable_amount}/-
                                </span>
                              )}
                            </span>

                            {/* <span>
                              CD :{" "}
                              <span className="textBold_grey">
                                {" "}
                                Rs{val.discounted_price.counpon_discount}
                              </span>
                              {}
                            </span> */}
                            {/* <span>
                              PC :{" "}
                              <span className="textBold_grey">
                                {" "}
                                Rs {val.discounted_price.phlebo_cost}
                              </span>
                              {}
                            </span> */}
                          </div>
                        </div>
                        <div className="bookingDetailsDiv">
                          <span className="hideDesktop">
                            Booking ID :{" "}
                            <span className="textBold_grey">{val.pk}</span>
                          </span>

                          <div>
                            Booked date:{" "}
                            <span className="textBold_grey">
                              {moment(val.booking_date).format("Do MMM YYYY")}
                            </span>
                          </div>
                          <div>
                            Payment:{" "}
                            <span className="textBold_grey">
                              {val.amount?.receivable_amount > 0
                                ? "Pending"
                                : "Completed"}
                            </span>
                          </div>
                          <div>
                            Transaction ID:{" "}
                            <span className="textBold_grey">
                              {val?.payment_source
                                ? val?.payment_source
                                : "N/A"}
                            </span>
                          </div>

                          <div className="bookedFor">
                            <div className="patientDetail">
                              Booked for:&nbsp;
                              <span className="textBold_grey">
                                {val.customer_name}
                              </span>
                            </div>
                            <div className="actionCall">
                              {val.amount.receivable_amount > 0 && (
                                <button
                                  onClick={() => handlePressEvent(val)}
                                  className=" book_nowBtn hover_dead"
                                  style={{
                                    background: "#e71850",
                                    color: "#fff",
                                  }}
                                >
                                  Pay Now
                                </button>
                              )}
                              {/* <button className=" book_nowBtn">
                                Track Phlebo
                              </button> */}
                            </div>
                          </div>
                        </div>

                        <div className="schedule_Div">
                          <div className="boking_left">
                            <span>
                              {val?.org_type == "imaging"
                                ? "Appointment Date and Time"
                                : "Scheduled Pickup on"}
                              :{" "}
                              <span className="textBold_grey">
                                {`${moment(val.collection_date).format(
                                  "Do MMM YYYY"
                                )} , ${val.collection_slot.start_time12hr} - ${val.collection_slot.end_time12hr}`}
                              </span>
                            </span>
                            <span>
                              {val?.org_type == "imaging"
                                ? " Center Address"
                                : " Pickup Address"}
                              :{" "}
                              <span className="textBold_grey">
                                {val?.org_type == "imaging" &&
                                  val?.center_address?.address
                                  ? `${val?.center_address?.address}`
                                  : `${val?.customer_address}, ${val?.landmark
                                    ? val?.landmark
                                    : val?.customer_landmark
                                  }`}
                              </span>
                            </span>
                          </div>
                          {/* <div className="boking_right">
                            <span className="trackPhlebo">Track Phlebo</span>
                          </div> */}
                        </div>
                        {val?.org_type == "imaging"
                          ? null
                          : val.phlebo.name &&
                          val.phlebo.phonenumber && (
                            <div className="bookingFooter">
                              <span>
                                Phlebo's Name:{" "}
                                <span className="textBold_grey">
                                  {" "}
                                  {val.phlebo.name}
                                </span>{" "}
                              </span>
                              <a
                                href={`tel:+91${val.phlebo.phonenumber}`}
                                style={{ color: "#0e416b" }}
                                className="phleboLink"
                              >
                                <span className="phoneIcon">
                                  <FiPhone />
                                </span>
                                {val.phlebo.phonenumber}
                              </a>
                            </div>
                          )}

                        <div className="bookedTestDetails">
                          <Inclusions val={val} />
                          {/* <PackDisplayblock item={val?.packages} /> */}
                        </div>
                      </div>
                    </>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default {
  component: ActiveDashboard,
};
